import MTileService from './m-tile-service.vue';

export default MTileService;